import React from 'react';
import { cn } from '@sglara/cn';
import { Typography } from 'design-system/src/components/Typography/Typography';
import ChevronRight from 'design-system/src/assets/icons/chevronRight.svg?react';
import { createTrackingProps } from 'shared-utils/analytics';

export type OnboardingSidePanelCardProps = {
  /**
   * PNG source for the gradient icon
   */
  icon: string;
  /**
   * Step title
   */
  title: string;
  /**
   * Step description
   */
  description: string;
  /**
   * Destination URL for the card
   */
  href: string;
  /**
   * Class name for additional styling
   */
  className?: string;
};

/**
 * A clickable card that represents an onboarding step in the GetStartedPanel.
 */
export const OnboardingSidePanelCard = ({
  icon,
  title,
  description,
  href,
  className,
}: OnboardingSidePanelCardProps) => {
  return (
    <a
      href={href}
      className={cn(
        'box-border flex w-full cursor-pointer items-center gap-4 rounded-lg border border-solid border-grayscale-100 bg-surface-100 p-4 text-left text-inherit no-underline transition-colors hover:bg-surface-200',
        className,
      )}
      {...createTrackingProps({ elementName: `Get Started Panel: ${title}` })}
    >
      <img src={icon} aria-hidden className="h-[70px] w-[50px] shrink-0 object-contain" />
      <div className="flex flex-1 flex-col gap-1">
        <Typography weight={600}>{title}</Typography>
        <Typography styledAs="bodySmallDMSans" color="var(--grayscale-600)">
          {description}
        </Typography>
      </div>
      <ChevronRight className="size-5 shrink-0 text-grayscale-400" aria-hidden />
    </a>
  );
};
